import './style/index.scss';

import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider, CssBaseline, ThemeProvider } from '@mui/material';

import theme from './theme';

import Routes from 'routes';

import { NavigationScroll } from 'components';

// ----------------------------------------------------------------------

function App() {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme()}>
				<CssBaseline />
				<BrowserRouter>
					<NavigationScroll>
						<Routes />
					</NavigationScroll>
				</BrowserRouter>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default App;
